import sliceCreator from '../../index.js';
import {ADMIN_DASHBOARD} from '../../../constants/index.js';
const _getAdminDashboardAction = sliceCreator('ADMIN_DASHBOARD', ADMIN_DASHBOARD, 'get');
 
const { asyncAction: getAdminDashboardAction, reducer, clearData: clearGetAdminDashboardAction } = _getAdminDashboardAction;
 
export default reducer;
 
export {
    getAdminDashboardAction,
    clearGetAdminDashboardAction,
}
 